module.exports = __webpack_public_path__ + "static/media/bg13.c9b95f45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg13.jpg
// module id = 847
// module chunks = 0